import { getCompanyDashboard, getEmployeeDashboard } from '../services/userService';

export const getDashboardData = async (id: string | number) => {
  let userResponse = null;
  try {
    const response = await getCompanyDashboard(id);
    console.log('dashboard', response);
    userResponse = response;
    if (userResponse) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      return { success: true, result: response.data };
    }
  } catch (e: any) {
    // console.log(e.response);
    return { success: false, error: e.response?.data?.message };
  }

  return userResponse;
};

export const getEmployeeDashboardData = async (id: string | number) => {
  let userResponse = null;
  try {
    console.log('id', id);
    const response = await getEmployeeDashboard(id);
    console.log('dashboard', response);
    userResponse = response;
    if (userResponse) {
      return { success: true, result: response?.data.data };
    }
  } catch (e: any) {
    // console.log(e.response);
    return { success: false, error: e.response?.data?.message };
  }

  return userResponse;
};
